import z from "zod";

export const ApiSchema = z.object({
  AUTOSAVE: z.string().optional(),
  AUTOSAVES: z.string().optional(),
  GET_AUTOSAVE: z.string().optional(),
  CONVERSATIONS: z.string().optional(),
  COMMENTS: z.string().optional(),
  IMAGE_UPLOAD: z.string().optional(),
  IMAGE_EDITOR_UPLOAD: z.string().optional(),
  FOLDERS: z.string().optional(),
  GENERATE_TEXT: z.string().optional(),
  GENERATE_PREHEADER: z.string().optional(),
  GENERATE_TRANSLATION: z.string().optional(),
  LOAD: z.string().optional(),
  PRODUCTS: z.string().optional(),
  FEEDS: z.string().optional(),
  PRODUCT_CATEGORIES: z.string().optional(),
  SAVE: z.string().optional(),
  SAVED_SECTIONS: z.string().optional(),
  TEST_EMAIL: z.string().optional(),
  PREMADE_TEMPLATES: z.string().optional(),
  PREMADE_TEMPLATE_CATEGORIES: z.string().optional(),
  PREMADE_TEMPLATES_KEYWORDS: z.string().optional(),
});

export const LockedApiSchema = z.object({
  AUTHORIZE: z.string(),
  GCS_SIGNED_URL: z.string(),
  GENERATE_CHAT: z.string(),
  GENERATE_IMAGE: z.string(),
  GENERATE_SECTION: z.string(),
  GENERATE_TEXT: z.string(),
  GENERATE_PREHEADER: z.string(),
  GENERATE_TRANSLATION: z.string(),
  GIPHY_API_KEY: z.string(),
  GIPHY_SEARCH: z.string(),
  PREVIEW_SAVE: z.string(),
});

export type IAPI = z.infer<typeof ApiSchema>;
export type ILockedAPI = z.infer<typeof LockedApiSchema>;
